import { useState } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import "./DashboardpagesCss/ChangePassword.css";
import { getUserData, getUserMobile } from "../../utils/auth";
import { ChangePwd, getOtp, validateOtp } from "../../api/api";
import toast from "react-hot-toast";

const ChangePassPage = () => {
  const { userData } = useOutletContext();
  const navigate = useNavigate();

  const ProfileData = getUserData();
  const mobileData = getUserMobile();
  const isLoggedin = Boolean(ProfileData);

  const [mobile, setMobile] = useState(userData?.mobile || "");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [isOtpVerified, setIsOtpverified] = useState(false);
  const [changeLoading, setChangeLoading] = useState(false);

  // Step 1: Request OTP
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        mobile_no: isLoggedin ? mobileData : mobile,
      };

      const res = await getOtp(payload);
      console.log("OTP Response:", res);

      if (res?.data?.status === "success") {
        toast.success("OTP sent successfully.");
        setShowOtp(true); // show OTP section
      } else {
        toast.error("Failed to generate OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error generating OTP:", error);
      toast.error("Failed to generate OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Step 2: Verify OTP
  const handleSubmitVerify = async (e) => {
    e.preventDefault();

    if (otp.length < 4) {
      toast.error("Please enter a valid 4-digit OTP.");
      return;
    }

    try {
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: isLoggedin ? mobileData : mobile,
        OTP: otp,
        Reg_status: "1",
      };

      const res = await validateOtp(payload);
      console.log("OTP Verification Response:", res);

      if (res?.data?.status === "success") {
        toast.success("OTP verified successfully.");
        setIsOtpverified(true);
        setShowOtp(false);
      } else {
        toast.error("OTP verification failed. Please try again.");
      }
    } catch (error) {
      console.error("OTP verification error:", error);
      toast.error("OTP verification failed. Please try again.");
    }
  };

  // Step 3: Change Password
  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (!newPassword || newPassword.length < 6) {
      toast.error("Password should be at least 6 characters.");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    setChangeLoading(true);
    try {
        const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      Mobile_no: isLoggedin ? mobileData : mobile,
      Password: newPassword,
      Pat_status:'1'
    };
      const res = await ChangePwd( payload );
      if(res?.data?.status === "success"){
      toast.success("Password changed successfully.");
      navigate("/users/login");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to change password. Please try again later.");
    } finally {
      setChangeLoading(false);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setMobile(value);
  };

  return (
    <div className="container">
      <div className="profile-header">
        <h2 className="rb-title pk-title package-tagg">Change Password</h2>
      </div>

      {/* Step 1: Mobile Number Form */}
      {!showOtp && !isOtpVerified && (
        <div className="edit-profile-form-wrapper">
          <form className="change-pass-form compact-form" onSubmit={handleSubmit}>
            <div className="input-group small-input-group">
              <label htmlFor="mobile" className="input-label">
                Mobile No
              </label>
              <input
                type="text"
                id="mobile"
                name="mobile"
                placeholder="Enter your mobile number"
                value={isLoggedin ? mobileData : mobile}
                onChange={handleChange}
                maxLength={10}
                disabled={isLoggedin}
                className="small-input"
              />
            </div>

            <div className="btn-section small-btn-section">
              <button type="submit" className="rbdButton small-btn" disabled={loading}>
                {loading ? "Sending OTP..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Step 2: OTP Verification Form */}
      {showOtp && !isOtpVerified && (
        <div className="edit-profile-form-wrapper">
          <form className="change-pass-form compact-form" onSubmit={handleSubmitVerify}>
            <div className="input-group small-input-group">
              <label htmlFor="otp" className="input-label">
                Enter OTP
              </label>
              <input
                type="text"
                id="otp"
                name="otp"
                placeholder="Enter 4-digit OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                maxLength={4}
                className="small-input"
              />
            </div>

            <div className="btn-section small-btn-section">
              <button type="submit" className="rbdButton small-btn">
                Verify OTP
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Step 3: New Password Form */}
      {isOtpVerified && (
        <div className="edit-profile-form-wrapper center-vertical">
          <form className="change-pass-form compact-form" onSubmit={handleChangePassword}>
            <div className="input-group small-input-group">
              <label htmlFor="newPassword" className="input-label">
                New Password
              </label>
              <input
                type="password"
                id="newPassword"
                name="newPassword"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="small-input"
              />
            </div>

            <div className="input-group small-input-group">
              <label htmlFor="confirmPassword" className="input-label">
                Confirm Password
              </label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="small-input"
              />
            </div>

            <div className="btn-section small-btn-section">
              <button type="submit" className="rbdButton small-btn" disabled={changeLoading}>
                {changeLoading ? "Please wait..." : "Change Password"}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default ChangePassPage;
